import { api } from "./api";

const PRODUCTS_KEY = "billone_products_cache";
const QUEUE_KEY = "billone_sale_queue";

export function cacheProducts(products) {
  try { localStorage.setItem(PRODUCTS_KEY, JSON.stringify(products || [])); } catch {}
}

export function getCachedProducts() {
  try { return JSON.parse(localStorage.getItem(PRODUCTS_KEY) || "[]"); } catch { return []; }
}

export function getQueue() {
  try { return JSON.parse(localStorage.getItem(QUEUE_KEY) || "[]"); } catch { return []; }
}

function saveQueue(q) {
  localStorage.setItem(QUEUE_KEY, JSON.stringify(q));
}

export function queueSale(payload) {
  const q = getQueue();
  q.push(payload);
  saveQueue(q);
}

export function isOnline() {
  return typeof navigator === "undefined" ? true : navigator.onLine;
}

export async function syncQueue() {
  if (!isOnline()) return { synced: 0, pending: getQueue().length };
  const q = getQueue();
  if (!q.length) return { synced: 0, pending: 0 };
  let synced = 0;
  const remaining = [];
  for (const item of q) {
    try {
      await api.post("/sales", item);
      synced++;
    } catch (e) {
      // keep in queue on failure (network)
      remaining.push(item);
    }
  }
  saveQueue(remaining);
  return { synced, pending: remaining.length };
}
